import React, { useState, useEffect, useRef } from "react";

const MediaShowcase = ({ mediaItems, showVideo = true }) => {
  const filteredMedia = showVideo
    ? mediaItems
    : mediaItems.filter((item) => item.type === "image");

  const [currentIndex, setCurrentIndex] = useState(0);
  const autoFlipRef = useRef(null);

  const prevMedia = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? filteredMedia.length - 1 : prev - 1
    );
  };

  const nextMedia = () => {
    setCurrentIndex((prev) =>
      prev === filteredMedia.length - 1 ? 0 : prev + 1
    );
  };

  // AUTO SLIDE
  useEffect(() => {
    autoFlipRef.current = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === filteredMedia.length - 1 ? 0 : prev + 1
      );
    }, 4500);

    return () => clearInterval(autoFlipRef.current);
  }, [filteredMedia.length]);

  const pauseAutoFlip = () => clearInterval(autoFlipRef.current);

  const resumeAutoFlip = () => {
    autoFlipRef.current = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === filteredMedia.length - 1 ? 0 : prev + 1
      );
    }, 4500);
  };

  return (
    <section className="w-full">
      <div className="max-w-[1180px] mx-auto">

        {/* MAIN CARD */}
        <div
          onMouseEnter={pauseAutoFlip}
          onMouseLeave={resumeAutoFlip}
          className="
            relative
            overflow-hidden
            rounded-[38px]
            bg-white/55
            backdrop-blur-2xl
            border
            border-white/50
            shadow-[0_35px_90px_rgba(20,10,0,.10)]
            p-3
            md:p-5
          "
        >

          {/* GLOW */}
          <div
            className="
              absolute
              top-0
              right-0
              w-72
              h-72
              bg-[#EBC8A8]/20
              rounded-full
              blur-3xl
            "
          />

          {/* MEDIA WRAPPER */}
          <div
            className="
              relative
              rounded-[30px]
              overflow-hidden
              bg-[#F8F4EF]
              aspect-[16/9]
            "
          >

            {/* IMAGE */}
            {filteredMedia[currentIndex].type === "image" && (
              <img
                src={filteredMedia[currentIndex].src}
                alt={`Media ${currentIndex + 1}`}
                className="
                  w-full
                  h-full
                  object-cover
                  transition-all
                  duration-700
                "
              />
            )}

            {/* VIDEO */}
            {filteredMedia[currentIndex].type === "video" && (
              <video
                className="w-full h-full object-cover"
                controls
                autoPlay
                muted
                loop
              >
                <source
                  src={filteredMedia[currentIndex].src}
                  type="video/mp4"
                />
              </video>
            )}

            {/* YOUTUBE */}
            {filteredMedia[currentIndex].type === "youtube" && (
              <iframe
                key={currentIndex}
                className="w-full h-full"
                src={`${filteredMedia[currentIndex].src}?autoplay=1&mute=1&rel=0&modestbranding=1&showinfo=0`}
                title="YouTube Video"
                frameBorder="0"
                allow="autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}

            {/* DARK OVERLAY */}
            <div
              className="
                absolute
                inset-0
                bg-gradient-to-t
                from-black/35
                via-transparent
                to-transparent
                pointer-events-none
              "
            />

            {/* NAVIGATION */}
            {filteredMedia.length > 1 && (
              <>
                <button
                  onClick={prevMedia}
                  className="
                    absolute
                    left-4
                    top-1/2
                    -translate-y-1/2
                    w-11
                    h-11
                    rounded-full
                    bg-white/15
                    backdrop-blur-xl
                    border
                    border-white/20
                    text-white
                    text-xl
                    transition-all
                    duration-300
                    hover:bg-white/25
                    z-20
                  "
                >
                  &#10094;
                </button>

                <button
                  onClick={nextMedia}
                  className="
                    absolute
                    right-4
                    top-1/2
                    -translate-y-1/2
                    w-11
                    h-11
                    rounded-full
                    bg-white/15
                    backdrop-blur-xl
                    border
                    border-white/20
                    text-white
                    text-xl
                    transition-all
                    duration-300
                    hover:bg-white/25
                    z-20
                  "
                >
                  &#10095;
                </button>
              </>
            )}

            {/* COUNTER */}
            <div
              className="
                absolute
                bottom-5
                right-5
                px-4
                py-2
                rounded-full
                bg-black/35
                backdrop-blur-xl
                border
                border-white/10
                text-white
                text-xs
                tracking-[.08em]
                z-20
              "
            >
              {currentIndex + 1} / {filteredMedia.length}
            </div>
          </div>
        </div>

        {/* DOTS */}
        {filteredMedia.length > 1 && (
          <div className="flex justify-center mt-6 gap-2">
            {filteredMedia.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`
                  transition-all
                  duration-300
                  rounded-full
                  ${
                    currentIndex === index
                      ? "w-10 h-2 bg-[#D98952]"
                      : "w-2 h-2 bg-[#D9C4B2]"
                  }
                `}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default MediaShowcase;